var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout-wrapper"}},[_c('NavBar'),_c('SideBar',{attrs:{"is-condensed":_vm.isMenuCondensed}}),_c('div',{staticClass:"main-content"},[_vm._t("default"),_c('Footer')],2),_c('RightBar',{ref:"notificationsBar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }